import script from "./DummyApplication.vue?vue&type=script&lang=ts&setup=true"
export * from "./DummyApplication.vue?vue&type=script&lang=ts&setup=true"

import "@klausapp/ui-kit/styles/variables.css?vue&type=style&index=0&lang=css&external"
import "@klausapp/ui-kit/styles/global.css?vue&type=style&index=1&lang=css&external"

const __exports__ = script;

export default __exports__